<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="a"
                :pages="[
                    {
                        name: $tc('messages.incidents', 2),
                        href: meta.links.index,
                    },
                    {
                        name: $t('messages.create'),
                        href: null,
                    },
                ]"
            />
        </template>

        <form :action="meta.links.store" method="post" @submit.prevent="submit">
            <TitleFieldsFormSection>
                <template v-slot:title>
                    {{ $t('messages.information') }}
                </template>
                <div class="md:grid md:grid-cols-6 md:gap-6">
                    <div class="sm:col-span-4">
                        <div class="mt-1">
                            <FormLabel :value="$tc('messages.places', 1)" for="place" />
                            <FormInput
                                required
                                id="place"
                                v-model="form.place"
                                name="place"
                                type="text"
                                class="mt-1 w-full"
                                list="places_suggestions"
                            />
                            <FormError :value="form.errors.place" class="mt-2" />
                            <datalist id="places_suggestions">
                                <option v-for="(place, index) in options.places" :value="place" :key="index" />
                            </datalist>
                        </div>
                    </div>

                    <div class="sm:col-span-2">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.type')" for="select_id" />
                            <FormSelect
                                required
                                id="select_id"
                                v-model="form.select_id"
                                :options="options.selects"
                                class="mt-1 w-full"
                            />
                            <FormError :value="form.errors.select_id" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.description')" for="description" />
                            <FormTextarea
                                required
                                id="description"
                                v-model="form.description"
                                name="description"
                                class="mt-2 w-full"
                            />
                            <FormError :value="form.errors.description" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.comment')" for="comment" />
                            <FormTextarea id="comment" v-model="form.comment" name="comment" class="mt-2 w-full" />
                            <FormError :value="form.errors.comment" class="mt-2" />
                        </div>
                    </div>

                    <div class="sm:col-span-6">
                        <div class="mt-1">
                            <FormLabel :value="$t('messages.priority')" for="priority" />
                            <div class="flex align-bottom" id="priority">
                                <div class="text-sm text-gray-500">
                                    {{ $t('messages.priority_low') }}
                                </div>
                                <div class="mx-4 text-center" v-for="priority in [1, 2, 3, 4, 5]" :key="priority">
                                    <FormLabel :value="priority" for="priority" />
                                    <input
                                        v-model="form.priority"
                                        :value="priority"
                                        type="radio"
                                        name="priority"
                                        class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
                                    />
                                </div>
                                <div class="text-sm text-gray-500">
                                    {{ $t('messages.priority_high') }}
                                </div>
                            </div>
                            <FormError :value="form.errors.priority" class="mt-2" />
                        </div>
                    </div>
                </div>
            </TitleFieldsFormSection>

            <div class="flex justify-end">
                <SubmitFormButton :button-text="$t('messages.save')" :processing="form.processing" />
            </div>
        </form>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import TitleFieldsFormSection from '@/components/TitleFieldsFormSection.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormError from '@/components/Forms/FormError.vue';
import FormSelect from '@/components/Forms/FormSelect.vue';
import FormTextarea from '@/components/Forms/FormTextarea.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';

export default {
    components: {
        SubmitFormButton,
        FormTextarea,
        PanelPage,
        TitleFieldsFormSection,
        FormInput,
        FormLabel,
        FormError,
        FormSelect,
    },
    layout: Layout,
    name: 'Create',
    props: ['meta', 'options'],
    data() {
        return {
            form: this.$inertia.form({
                place: '',
                description: '',
                comment: '',
                priority: '',
                user_id: '',
                select_id: '',
            }),
        };
    },
    methods: {
        submit() {
            this.form.post(this.meta.links.store);
        },
    },
};
</script>
